import { useState } from 'react';
import { Spinner } from '../../../../../components/Spinner';
import classNames from 'classnames';
// API
import { useEnv } from '../../../../../context/env-context';
import { useAuth } from '../../../../../hooks/useAuth';
import { makeRequest } from '../../../../../utils/makeRequest';
import { toast } from 'react-toastify';
// components
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
// constants
import { REPAYMENT_MODE_BADGE } from '../../../../../constants/fundings';

function NewFundingPopoverRepaymentModeForm({ fundingId, fundingRepaymentMode, refreshFunding }) {
  const { apiOriginFunding } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const [isOpen, setIsOpen] = useState(false);
  const [spinner, setSpinner] = useState(false);

  const changeRepaymentMode = async (mode, message) => {
    if (window.confirm(message)) {
      setSpinner(true);
      const token = await getAccessTokenSilently();

      if (!token) {
        return;
      }

      const config = {
        token,
        url: `${apiOriginFunding}/change_repayment_mode`,
        method: 'POST',
        data: JSON.stringify({ fundingId, mode }),
      };

      try {
        await makeRequest(config);
        await refreshFunding();

        toast.success(`Repayment mode successfully modified to ${mode}`);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setSpinner(false);
        setIsOpen(false);
      }
    }
  };

  const handleToggle = () => setIsOpen(!isOpen);

  return (
    <OverlayTrigger
      trigger="click"
      placement="bottom-start"
      show={isOpen}
      popperConfig={{ modifiers: [{ name: 'offset', options: { offset: [0, 4] } }] }}
      overlay={
        <Popover className="custom-popover">
          <Popover.Body className="bo-common-popover-form-menu">
            <Spinner visible={spinner} size={36}>
              <div className="d-flex flex-column gap-2">
                {Object.entries(REPAYMENT_MODE_BADGE)
                  .filter(([key]) => key !== 'IMMEDIATE' && key !== 'REPAID')
                  .map(([key, value]) => (
                    <Button
                      key={key}
                      className="bo-common-base-button"
                      onClick={() => changeRepaymentMode(key)}
                    >
                      <Badge
                        className={classNames(
                          'bo-inline-badge',
                          'bo-common-inline-badge-hover',
                          'shadow-sm',
                          'bo-w-180',
                          value?.color,
                        )}
                      >
                        {value?.text}
                      </Badge>
                    </Button>
                  ))}
              </div>
              <div className="d-flex justify-content-center mt-3">
                <Button className="bo-common-button" onClick={handleToggle}>
                  Cancel
                </Button>
              </div>
            </Spinner>
          </Popover.Body>
        </Popover>
      }
    >
      <Button onClick={handleToggle} className="bo-common-popover-form-toggle">
        <Badge
          className={classNames(
            'bo-common-inline-badge',
            REPAYMENT_MODE_BADGE[fundingRepaymentMode]?.color,
          )}
        >
          {REPAYMENT_MODE_BADGE[fundingRepaymentMode]?.text}
        </Badge>
      </Button>
    </OverlayTrigger>
  );
}

export default NewFundingPopoverRepaymentModeForm;
